import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import MetaTags from 'react-meta-tags';
import Prismic from 'prismic-javascript';

import Header from '../../components/header';
import Newsletter from '../../components/newsletter';
import Footer from '../../components/footer';
import Breadcrumbs from '../../components/breadcrumbs';
import BarContact from '../../components/bar-contact';
import SidebarContact from '../../components/sidebar-contact';
import FormWorkWithUsPtBr from './form-work-with-us-pt-br';
import FormWorkWithUsEnUs from './form-work-with-us-en-us';
import FormWorkWithUsEsEs from './form-work-with-us-es-es';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 48px 0 92px;
  .wrapper {
    align-items: flex-start;
    justify-content: space-between;
    article {
      width: 50%;
    }
    aside {
      width: 35%;
    }
    @media (max-width: 900px) {
      flex-wrap: wrap;
      aside,
      article {
        max-width: 100%;
        width: 100%;
        margin-left: 0;
      }
      aside {
        margin-top: 80px;
      }
    }
  }
`

class WorkWithUs extends Component {
  state = {
    seo: {}
  };

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== this.state.language) {
      window.scrollTo(0, 0)
      this.setState({language: language});
      this.getContent();
    }
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({language: language});
    this.getContent();
  }

  getContent = () => {
    const { language } = this.context;

    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);

    const fetchDataSeo = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'seo_trabalhe_conosco'),
        {lang: language}
      )
      if (response)
        this.setState({seo: response.results[0].data});
    }
    fetchDataSeo();
  }

  render = () => {
    const { language } = this.context;
    let home = ''
    let contato = ''
    let titulo = ''
    switch (language) {
      case 'pt-br':
        titulo = 'Trabalhe conosco'
        home = 'Início'
        contato = 'Contato'
        break;
      case 'en-us':
        titulo = 'Work with us'
        home = 'Home'
        contato = 'Contact'
        break;
      case 'es-es':
        titulo = 'Trabaja con nosostros'
        home = 'Inicio'
        contato = 'Contacto'
        break;
      default:
    }
    return (
      <div id="home">
        <MetaTags>
          <title>{ this.state.seo.meta_title }</title>
          <meta id="meta-description" name="description" content={ this.state.seo.meta_description } />
          <meta id="og-title" property="og:title" content={ this.state.seo.meta_title } />
        </MetaTags>
        <Header />
        <Breadcrumbs title={ titulo }>
          <div>
            <Link to="/">{ home }</Link>
            <Link to="/contato">{ contato }</Link>
            <span>{ titulo }</span>
          </div>
        </Breadcrumbs>
        <BarContact active="trabalhe-conosco" />
        <Container>
          <div className="wrapper flex">
            <article>
              { language === 'pt-br' && <FormWorkWithUsPtBr /> }
              { language === 'es-es' && <FormWorkWithUsEsEs /> }
              { language === 'en-us' && <FormWorkWithUsEnUs /> }
            </article>
            <aside>
              <SidebarContact />
            </aside>
          </div>
        </Container>
        <Newsletter />
        <Footer />
      </div>
    );
  }
}

WorkWithUs.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
};

WorkWithUs.contextType = LanguageContext;

export default WorkWithUs;
